import React, {Component} from 'react';
import {Button, Modal, Table, Popup} from 'semantic-ui-react';

import Loading from "../extras/Loading";
import IngredientStockData from "../../data/IngredientStockData";
import IngredientStockUpdate from "./IngredientStockUpdate";
import {connect} from "react-redux";
import {openModalIngredientStock} from "../../actions/ModalIngredientStockActions";
import {listIngredientsStock} from "../../actions/IngredientStockActions";
import {openModalIngredientStockUpdate} from "../../actions/ModalIngredientStockUpdateActions";

class IngredientCurrentStockModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            header: ['Sucursal', 'Unidades Disponibles', 'Acciones'],
            loading: true,
            data: null
        };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.modal.data && this.state.data === null){
            IngredientStockData.listByIngredient(nextProps.modal.data.id).then((data)=>{
                this.setState({loading:false, data:nextProps.modal.data});
                this.props.listIngredientsStock(data);
            });
        }
    }

    handleClose = () => {
        this.props.openModalIngredientStock({data:{name:null}, is_open:false});
        this.setState({loading:true, data:null});
    };

    updateDialog = (stock, is_add) => {
        this.props.openModalIngredientStockUpdate({
            is_open: true,
            is_add,
            ingredient:{
                name: this.props.modal.data.name,
                id: this.props.modal.data.id
            },
            stock
        });
    };

    render() {
        let rows = this.props.ingredients_stock.map(stock => {
            return (
                <Table.Row
                    key={stock.id}
                    negative={stock.total <= 5 }
                    warning={stock.total > 5 && stock.total <= 10}
                >
                    <Table.Cell>{stock.name}</Table.Cell>
                    <Table.Cell>{Number.isInteger(stock.total) ? stock.total:Math.round((stock.total + Number.EPSILON) * 100) / 100}</Table.Cell>
                    <Table.Cell>
                        <Button.Group basic size='small'>
                            <Popup
                                trigger={<Button icon='plus' onClick={() => this.updateDialog(stock, true)}/>}
                                content='Agregar al Inventario'
                                size='small'
                            />
                            <Popup
                                trigger={<Button icon='remove' onClick={() => this.updateDialog(stock, false)}/>}
                                content='Quitar del Inventario'
                                size='small'
                            />
                        </Button.Group>
                    </Table.Cell>
                </Table.Row>
            )
        }, this);

        let header = this.state.header.map(function (header, i) {
            return (
                <Table.HeaderCell key={i}>
                    {header}
                </Table.HeaderCell>
            )
        }, this);

        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.props.modal.is_open} onClose={this.handleClose}>
                    <Modal.Header>{`${this.props.modal.data.name} - Inventario`}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {this.state.loading ? <div style={{height:50}}><Loading/></div> : null}
                            {this.state.loading ? null :
                                <Table celled>
                                    <Table.Header>
                                        <Table.Row>{header}</Table.Row>
                                    </Table.Header>
                                    <Table.Body>{rows}</Table.Body>
                                </Table>}
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
                <IngredientStockUpdate />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('ingredient_stock_modal'),
        ingredients_stock: state.get('ingredients_stock')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openModalIngredientStock(modal){
            dispatch(openModalIngredientStock(modal))
        },
        listIngredientsStock(ingredients_stock){
            dispatch(listIngredientsStock(ingredients_stock))
        },
        openModalIngredientStockUpdate(modal){
            dispatch(openModalIngredientStockUpdate(modal))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IngredientCurrentStockModal);



// WEBPACK FOOTER //
// ./src/components/inventories/IngredientCurrentStockModal.js